<template>
    <div class="page">
        <div class="container">
            <img class="logo" src="~@/assets/pay-success.png" alt="" />
            <div class="title">
                {{ type == "RECHARGE" ? "充值成功" : "购买成功" }}
            </div>
            <div class="intro" v-if="type == 'RECHARGE'">
                充值成功！本次充值{{ chongzhi.recharge }}元，{{
                    chongzhi.gift > 0 ? `达哥送您${chongzhi.gift}牛币` : ""
                }}，已实时到账。<br />
            </div>
            <div class="intro gift" v-else-if="type == 'XUNI'">
                <!-- {{ xuni.gift.length > 0 ? xuni.message : "" }}
                <a
                    class="getPrize"
                    v-if="xuni.gift.length > 0 && xuni.giftType == 'SHIWU'"
                    @click="goGetPrizeMethod(xuni.giftId)"
                >
                    去领取
                </a>
                <br />如有疑问请添加客服微信：<br />
                <b>daodahao1997</b> -->
                <div class="msg">{{ xuni.message }}</div>
                <div class="btns">
                    <button class="btn" @click="goGetPrizeMethod(xuni.giftId)">
                        填写收货地址
                    </button>
                    <button class="btn" @click="goPayed()">查看已购</button>
                </div>
            </div>
            <div class="intro" v-else-if="type == 'LUCKY_DRAW'">
                恭喜您获取一次抽奖机会，<a
                    @click="goChoujiang()"
                    class="goChoujiang"
                >
                    前往抽奖
                </a>
            </div>
            <div class="goHome-box" v-else>
                <button class="btn goHome" @click="goHome">
                    返回首页
                </button>
            </div>

            <div class="qrcode-box">
                <div class="name-box">
                    <span>售后服务</span>
                </div>
                <div class="notice">
                    问题咨询请长按扫码添加客服
                </div>
                <img class="qrcode" :src="xuni.kefu" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
    import payService from "../../service/pay.service";
    import { Chongzhi, Xini, Choujiang } from "../../types/pay";
    export default {
        name: "pay-success",
        data() {
            return {
                type: undefined,
                orderId: undefined,
                chongzhi: new Chongzhi(),
                xuni: new Xini(),
                choujiang: new Choujiang(),
                redirect: "",
            };
        },
        created() {
            this.orderId = this.$route.query.orderId;
            this.getOrderById();
        },
        methods: {
            goHome() {
                // this.$router.push("/index");
                if (this.redirect) {
                    window.location.href = this.redirect;
                }
            },
            goPayed() {
                this.$router.push("/course-list");
            },
            getOrderById() {
                payService
                    .getOrderById({
                        orderId: this.orderId,
                    })
                    .then((res) => {
                        this.type = res.data.type;
                        // this.type = null;
                        switch (this.type) {
                            case "RECHARGE":
                                this.chongzhi = res.data;
                                return;
                            case "XUNI":
                                this.xuni = res.data;
                                return;
                            case "LUCKY_DRAW":
                                this.choujiang = res.data;
                                return;
                            default:
                                this.xuni = res.data;
                        }
                        this.redirect = res.data.redirect;
                        // if (res.data.redirect) {
                        //     setTimeout(() => {
                        //         this.$router.push("/course-list");
                        //     }, 1000);
                        // }
                    });
            },
            goGetPrizeMethod(id) {
                this.$router.push({ path: "/get-prize-method", query: { id } });
            },
            goChoujiang() {
                this.$router.push({
                    path: "/choujiang",
                    query: { id: this.choujiang.activityId },
                });
            },
        },
    };
</script>

<style lang="scss" scoped src="./pay-success.scss"></style>
